import { useQuery } from '@tanstack/react-query'
import { PlayLogService } from '../../services/playlog.service'
import type { operations } from '@/schema'
import { DashboardKeys } from '@/modules/dashboard/keys'

type GetGameProvidersParams =
	operations['GameController_getGameProviderListForAdmin']['parameters']['query']

export default function useQueryGetGameProviders(
	params: GetGameProvidersParams,
) {
	return useQuery({
		queryKey: [DashboardKeys.GameProviders, params],
		queryFn: () => PlayLogService.getGameProviders(params),
	})
}
